import {
  Component,
  Host,
  Prop,
  h,
} from "@stencil/core";

import { Font } from "../../index";

/**
 * @slot - Slot for any (mostly form) elements
 */
@Component({
  tag: "stzh-fieldset",
  styleUrl: "stzh-fieldset.scss",
  scoped: true
})
export class StzhFieldset {
  /** Legend describing the field group inside the fieldset */
  @Prop() legend: string = "";

  /** Hide legend to show only for screenreaders */
  @Prop() hideLegend: boolean = false;

  /** Heading level inside legend */
  @Prop() legendLevel: "" | "1" | "2" | "3" | "4" = "";

  /** Type of curve to overwrite the curve inherited from `level` attribute (see [Spacings docs page](/docs/tokens-typography--docs#curves) for more info). */
  @Prop() legendCurve: Font.Curves | "auto" = "auto";

  render() {
    const classes = {
      "stzh-fieldset": true,
      "stzh-fieldset--hide-legend": this.hideLegend
    };

    return (
      <Host>
        <fieldset class={classes}>
          {this.legend &&
            <legend class="stzh-fieldset__legend">
              {this.legendLevel ?
                <stzh-heading
                  level={this.legendLevel}
                  curve={this.legendCurve}
                >
                  {this.legend}
                </stzh-heading>
              :
                this.legend
              }
            </legend>
          }
          <div class="stzh-fieldset__wrapper">
            <slot></slot>
          </div>
        </fieldset>
      </Host>
    );
  }
}
